export default __webpack_public_path__ + "static/media/logo_big_shadow.d4468f81.png";